module.exports = __webpack_public_path__ + "static/Agenda-Template-Show-Ending-Times-And-Locations-3dbcf81a036820f93a26b431e845fdae.png";